import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface EngineMechanicsProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function EngineMechanics(props: EngineMechanicsProps) {
  return (
    <svg
      width="56"
      height="98"
      viewBox="0 0 56 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 202, left: 227}}
      onClick={props.onClick}
    >
      <path
        d="M1 88L1 49L1 10C1 1 11 1 11 1H55V97H11C11 97 1 97 1 88Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M1 88L1 49L1 10C1 1 11 1 11 1H55V97H11C11 97 1 97 1 88Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path d="M11 1V97" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path
        d="M1 49L55 49"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
